import { type AnyRoute, routeMap } from '../route.ts'

export const getRoutes = (
  filter: (route: AnyRoute) => boolean = () => true
): AnyRoute[] =>
  Object.values(routeMap)
    .map((r) => r())
    .sort((a, b) => b.length - a.length)
    .filter(filter)
